import React from "react";
import FlashcardsJourneyView from "./FlashcardsJourneyView.js";

function FlashcardsInJourney({ questionsCount = 10, onComplete, config }) {
    return (
        <FlashcardsJourneyView
            inJourney={true}
            gameLength={questionsCount}
            suppressBackground={true}
            onComplete={onComplete}
            config={config}
        />
    );
}

export default FlashcardsInJourney;